// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://dzgocgmnozogkpbadfke.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImR6Z29jZ21ub3pvZ2twYmFkZmtlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDcxNDYxMDgsImV4cCI6MjA2MjcyMjEwOH0.45iYdJI202pY03CQCuUSVarc9TlnY7_R7yjf03ONN48";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);